import axios from 'axios'

const util = require('../../util.js')

const default_filter = {
  name: null,
  groupSource: null,
  groupType: null,
  ownerOrganizationNumber: null,
  memberUserId: null,
  isValid: Boolean(true)
}

const default_paging = {
  currentPage: 1,
  perPage: 25,
  perPageAlternatives: [25, 50, 100],
  totalRows: 0
}
const default_group = {
  name: undefined,
  groupSource: undefined,
  groupType: undefined,
  organization: undefined,
  active: undefined
}
const state = {
  filter: { ...default_filter },
  groups: [],
  group: { ...default_group },
  paging: { ...default_paging },
  members: [],
  loading: false
}

const mutations = {
  UPDATE_GROUPS (state, payload) {
    state.groups = payload.response
    state.paging.totalRows = payload.resultCount
  },
  UPDATE_GROUP (state, payload) {
    state.group = payload
  },
  UPDATE_FILTER (state, payload) {
    state.filter = payload
  },
  UPDATE_PAGING (state, payload) {
    state.paging = payload
  },
  UPDATE_GROUP_MEMBERS (state, payload) {
    state.members = payload
  },
  UPDATE_FORM_DISABLE_INDICATOR (state, payload) {
    state.loading = payload
  },
  UPDATE_ORGANIZATION_NUMBER (state, payload) {
    state.filter.ownerOrganizationNumber = payload
  },
  UPDATE_MEMBER_USER_ID (state, payload) {
    state.filter.memberUserId = payload
  }
}

const actions = {
  async getGroups ({ commit, dispatch }) {
    commit('UPDATE_FORM_DISABLE_INDICATOR', true)
    await dispatch('getSelectedActiveProfile')
    axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/group', {
        params: {
          name: util.emptyToNull(state.filter.name),
          groupSource: util.emptyToNull(state.filter.groupSource),
          groupType: util.emptyToNull((state.filter.groupType)),
          ownerOrganizationNumber: util.emptyToNull(state.filter.ownerOrganizationNumber),
          memberUserId: util.emptyToNull(state.filter.memberUserId),
          valid: state.filter.isValid,
          pageNumber: util.emptyToNull(state.paging.currentPage),
          pageSize: util.emptyToNull(state.paging.perPage),
        }
      }).then(response => {
      commit('UPDATE_GROUPS', response.data)
    }).finally(() => {
      commit('UPDATE_FORM_DISABLE_INDICATOR', false)
    })
  },
  resetFilter ({ commit }) {
    commit('UPDATE_PAGING', { ...default_paging })
    commit('UPDATE_FILTER', { ...default_filter })
    state.groups = []
  },
  getGroupByGroupId ({ commit }, id) {
    axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/group/get?groupId=' + encodeURIComponent(id))
      .then((response) => {
        commit('UPDATE_GROUP', response.data)
      })
  },
  getGroupMembers ({ commit }, id) {
    axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/group/get/members?groupId=' + encodeURIComponent(id))
      .then((response) => {
        commit('UPDATE_GROUP_MEMBERS', response.data.members)
      })
  },
  getSelectedActiveProfile ({ commit, rootGetters }) {
    let isActiveProfileSelected = rootGetters['sessionStorage/isActiveProfileSet']
    if(isActiveProfileSelected) {
      let activeProfile = rootGetters['sessionStorage/activeProfile']
      if(activeProfile.activeProfileType === 'organization') {
        commit('UPDATE_ORGANIZATION_NUMBER', activeProfile.id)
      } else {
      commit('UPDATE_MEMBER_USER_ID', activeProfile.id)
    }
    }
  },
  getGroupsByOwnerOrganizationNumber ({ commit }, payload) {
    commit('UPDATE_ORGANIZATION_NUMBER', payload)
  },
}

const getters = {
  filter: state => state.filter,
  groups: state => state.groups,
  paging: state => state.paging,
  group: state => state.group,
  members: state => state.members,
  loading: state => state.loading
}

const groupsModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
export default groupsModule